export default __webpack_public_path__ + "static/home-page-career-fit-91ff615558ec3670f895d08680f9c6a9.png";